<template>
  <div
    class="numeric-entry"
    data-test="numeric-entry-question"
  >
    <input
      v-model="input"
      data-test="numeric-entry-input"
      type="number"
      @blur="handleBlur"
    />
    <label>{{ numericLabel }}</label>
  </div>
</template>

<script>
export default {
  props: {
    flashcard: {
      type: Object,
      required: true,
    },
    flashcardState: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      input: '',
    };
  },
  computed: {
    numericLabel() {
      const firstAnswer = this.flashcard?.answers[0];
      if (!firstAnswer) return '';
      return JSON.parse(firstAnswer.text).unit || '';
    },
  },
  watch: {
    flashcardState() {
      this.input = this.flashcardState?.rawAnswerData?.numeric || '';
    },
  },
  mounted() {
    this.input = this.flashcardState?.rawAnswerData?.numeric || '';
  },
  methods: {
    handleBlur() {
      this.$emit('set-raw-answer-data', { numeric: this.input });
    },
  },
};
</script>

<style lang="scss" scoped>
.numeric-entry {
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

input {
  border: 1px solid black;
  display: inline-block;
  font-size: 0.875rem;
  height: 1.5625rem;
  max-width: 10rem;
  padding: 0.3125rem;
  text-align: right;
}

label {
  margin-left: 0.25rem;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  display: none;
}
</style>
